import { render, staticRenderFns } from "./PuzzleGrid.vue?vue&type=template&id=45fbcb1a"
import script from "./PuzzleGrid.vue?vue&type=script&lang=ts"
export * from "./PuzzleGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports